/**
 * Resets transient UI state on route changes: closes dialogs and clears header snackbars.
 *
 * Merges former closeAllDialogs + closeAllSnackbars global middleware.
 */
export default defineNuxtRouteMiddleware((to, from) => {
  if (from.path === to.path) return

  const { closeAllDialogs } = useDialog()
  closeAllDialogs()

  const { clearAllSnackbars } = useHeaderSnackbars()
  if (
    from.name !== 'localized-checkout-adyen' &&
    from.name !== 'localized-checkout-paypal'
  ) {
    clearAllSnackbars()
  }
})
